import { FC, useEffect } from 'react';
import { useParams, Navigate, Link as BrowserLink } from 'react-router-dom';
import i18n from 'i18next';
import { Alert, Button, Grid } from '@material-ui/core';
import { LoginContainer } from 'src/components/loginContainer';
import { useAppDispatch, useAppSelector } from 'src/hooks/useStore';
import { selectAuth, validateResetdToken } from './authSlice';

const LinkValidationPage: FC = () => {
  const { token } = useParams();
  const dispatch = useAppDispatch();
  const { status } = useAppSelector(selectAuth);

  useEffect(() => {
    dispatch(validateResetdToken(token));
  }, [token]);

  if (status === 'success') {
    return <Navigate to={`/password-reset/${token}`} />;
  }

  return (
    <LoginContainer>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {status === 'error' && (
            <Alert severity="error" sx={{ mt: 3 }}>
              {i18n.t('expiredToken')}
            </Alert>
          )}
        </Grid>

        <Grid item xs={12}>
          <Button
            component={BrowserLink}
            to="/login"
            color="primary"
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            Authentification
          </Button>
        </Grid>
      </Grid>
    </LoginContainer>
  );
};
export default LinkValidationPage;
